export default "__VITE_ASSET__8NGsgxlt__"